import request from 'superagent'
import router from '../router/index'

const PRO_SERVER = process.env.API_ROOT;
const Login_OUT_PATH = process.env.Login_OUT;

function getUrl(path) {
    if (path.startsWith('http') || path.startsWith('https')) {
        return path;
    }
    return `${PRO_SERVER}${path}`;
}
const errorHandler = (err) => {
    if (err.response && err.response.status == 401 && JSON.parse(err.response.text).msg == 'unauthorized') {
        router.push({ name: 'login' })
        return false;
    }

    var str = err.response.status
    str += ' - '
    str += err.response.statusText
    str += '<br/>请求路径：<br/>'
    str += err.response.error.url
}

const HttpClient = {
    path: PRO_SERVER,
    loginoutPath: Login_OUT_PATH,
    get: (path, query, token) => new Promise((resolve, reject) => {
        var req = request
            .get(getUrl(path))
            .withCredentials()
            .set('Content-Type', 'application/json')
            .set("x-auth-token", token)
            .query(query)
            .end((err, res) => {
                if (err) {
                    errorHandler(err)
                    reject(err);
                } else {
                    resolve(res.body);
                }
            });
    }),
    login: (path, formdata, query) => new Promise((resolve, reject) => {
        request
            .post(getUrl(path))
            .withCredentials()
            .set('Content-Type', 'application/json')
            .query(query)
            .send(formdata)
            .end((err, res) => {
                if (err) {
                    errorHandler(err)
                    reject(err);
                } else {
                    if (res.header['x-auth-token'] && path.indexOf('/login') > -1) {
                        window.sessionStorage.setItem('access_token', res.header['x-auth-token']);
                    }
                    resolve(res.body);
                }
            });
    }),

    post: (path, formdata, query) => new Promise((resolve, reject) => {
        // var token = window.sessionStorage.getItem('access_token');
        // if (token) {
            request
                .post(getUrl(path))
                .withCredentials()
                .set('Content-Type', 'application/json')
                // .set('x-auth-token', token)
                .query(query)
                .send(formdata)
                .end((err, res) => {
                    if (err) {
                        // console.log(err);
                        errorHandler(err)
                        reject(err);
                    } else {
                        if (res.body.head.responseCode == '10701') {
                            // console.log(process.env.SSO + `/login?service=${PRO_SERVER}/index`);
                            window.location.href = process.env.SSO + `/login?service=${PRO_SERVER}/index`;
                        }
                        else {
                            resolve(res.body);
                        }
                    }
                });
        // }
    }),
    resetPost: (path, formdata, query) => new Promise((resolve, reject) => {
        request
        .post(getUrl(path))
        .withCredentials()
        .set('Content-Type', 'application/json')
        .query(query)
        .send(formdata)
        .end((err, res) => {
            if (err) {
                errorHandler(err);
                reject(err);
            } else {
                resolve(res.body);
            }
        });
    }),
    put: (path, query, payload) => new Promise((resolve, reject) => {
        request
            .put(getUrl(path))
            .query(query)
            .send(payload)
            .end((err, res) => {
                if (err) {
                    errorHandler(err)
                    reject(err);
                } else {
                    resolve(res.body);
                }
            });
    }),
    delete: (path, query) => new Promise((resolve, reject) => {
        request
            .del(getUrl(path))
            .withCredentials()
            .query(query)
            .end((err, res) => {
                if (err) {
                    errorHandler(err)
                    reject(err);
                } else {
                    resolve(res);
                }
            });
    })
};

export default HttpClient;


// WEBPACK FOOTER //
// ./src/utils/httpClient.js